import 'core-js/actual';
import 'intl-pluralrules';
import 'whatwg-fetch';

import { createRoot } from 'react-dom/client';

import '../setup';

import { setupTranslations } from '../i18n';
import App from './App';

setupTranslations({
  namespaces: [
    'frontend',
    'common',
  ],
});

const container = document.getElementById('app');
const root = createRoot(container);
root.render(<App />);
